'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResults = function (_Component) {
  _inherits(SearchResults, _Component);

  function SearchResults() {
    _classCallCheck(this, SearchResults);

    return _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).apply(this, arguments));
  }

  _createClass(SearchResults, [{
    key: 'render',
    value: function render() {
      var classNames = this.props.classNames;


      return _react2.default.createElement(
        'div',
        { className: 'c11n-search-results ' + classNames.root },
        this.renderSearchResults()
      );
    }
  }, {
    key: 'renderSearchResults',
    value: function renderSearchResults() {
      var _props = this.props,
          children = _props.children,
          loading = _props.loading,
          error = _props.error;


      if (loading) {
        return this.renderLoading();
      }

      if (error) {
        return this.renderError();
      }

      if ((0, _isEmpty2.default)(children)) {
        return this.renderEmpty();
      }

      return this.renderResults();
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.state },
        _react2.default.createElement(_icon2.default, { name: 'loading', size: 2, spin: true })
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.state },
        _react2.default.createElement(_icon2.default, { name: 'warning' }),
        this.props.errorLabel
      );
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.state },
        _react2.default.createElement(_icon2.default, { name: 'warning' }),
        this.props.emptyLabel
      );
    }
  }, {
    key: 'renderResults',
    value: function renderResults() {
      return _react2.default.createElement(
        'ul',
        null,
        this.props.children
      );
    }
  }]);

  return SearchResults;
}(_react.Component);

SearchResults.propTypes = {
  /**
   * An an array of leaderboard items for each leader
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),

  /**
   * If the results are currently loading
   */
  loading: _propTypes2.default.bool,

  /**
   * Set the error message or set to true to show default message
   */
  error: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),

  /**
   * Set the message to display if there are no results
   */
  emptyLabel: _propTypes2.default.string,

  /**
   * Set the message to display if there is an error
   */
  errorLabel: _propTypes2.default.string,

  /**
   * The background color for the leaderboard
   */
  background: _propTypes2.default.string,

  /**
   * The foreground color for the leaderboard
   */
  foreground: _propTypes2.default.string,

  /**
   * Custom styles to be applied to root, leaders
   */
  styles: _propTypes2.default.object
};

SearchResults.defaultProps = {
  styles: {},
  emptyLabel: 'No results found',
  errorLabel: 'There was an error loading the results'
};

exports.default = (0, _withStyles2.default)(_styles2.default)(SearchResults);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/search-results/index.js
// module id = 154
// module chunks = 0